import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, Search } from "lucide-react";
import { api } from "@/lib/api";
import { tanggal } from "@/lib/format";
import { PublicPage } from "@/components/landing/PublicPage";
import { TONE } from "@/components/landing/AnnouncementsSection";
import { Input } from "@/components/ui/input";

export default function Pengumuman() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/announcements").then((r) => setItems(r.data.filter((a) => a.active))).catch(() => setItems([]));
  }, []);
  const shown = (items || []).filter((a) => `${a.title} ${a.content}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <PublicPage testId="pengumuman-page" eyebrow="Informasi Terbaru" title="Pengumuman Masjid" desc="Semua informasi resmi dari pengurus DKM Al-Iman untuk jamaah: jadwal kajian, penggalangan dana, hingga pemberitahuan kegiatan.">
      <div className="relative max-w-md">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari pengumuman..." className="pl-9 rounded-full bg-white" data-testid="pengumuman-search" />
      </div>
      <div className="mt-8 grid lg:grid-cols-2 gap-5">
        {shown.map((a) => (
          <Link to={`/pengumuman/${a.id}`} key={a.id} className="card-hover block rounded-3xl bg-white border border-emerald-900/10 p-6" data-testid={`pengumuman-card-${a.id}`}>
            <div className="flex items-center justify-between gap-3">
              <span className={`text-[11px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full ${TONE[a.priority] || TONE.normal}`}>{a.priority}</span>
              <span className="text-xs text-slate-400">{tanggal(a.created_at?.slice(0, 10))}</span>
            </div>
            <h3 className="mt-4 font-bold text-emerald-950 text-lg">{a.title}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-3">{a.content}</p>
            <p className="mt-4 text-sm font-semibold text-emerald-800">Baca selengkapnya →</p>
          </Link>
        ))}
        {items && shown.length === 0 && (
          <div className="col-span-full rounded-3xl border border-dashed border-emerald-900/20 p-12 text-center text-slate-500" data-testid="pengumuman-empty">
            <Megaphone className="mx-auto mb-3 text-emerald-700" /> Tidak ada pengumuman.
          </div>
        )}
      </div>
    </PublicPage>
  );
}
